<div class="d-md-flex auth-wrapper">
  <div class="col-md-6 page-left-side d-none d-md-flex align-items-center justify-content-center">
    <a [routerLink]="['/']" class="auth-center-logo-link">
      <img
        [src]="tenantConfigService.tenant.coloredLogoUrl"
        [alt]="(tenantConfigService.tenant.companyName || 'Company') + ' Logo'"
        class="auth-center-logo"
      />
    </a>
  </div>
  <div class="col-12 col-md-6 page-right-side">
    <div class="auth-header-bar">
      <div class="logo d-md-none">
        <a [routerLink]="['/']">
          <img
            [src]="tenantConfigService.tenant.coloredLogoUrl"
            [alt]="
              (tenantConfigService.tenant.companyName || 'Company') + ' Logo'
            "
            class="auth-logo"
          />
        </a>
      </div>
      <div class="language-container">
        <select
          class="language-select"
          (change)="onLanguageChange($event)"
          [value]="languageService.currentLanguage"
        >
          <option value="en">English</option>
          <option value="ar">العربية</option>
        </select>
      </div>
    </div>

    <div class="col-12 form-content">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </div>

    <div class="auth-bottom-spacer"></div>
  </div>
</div>
